/** Egyptian governorates (same list as checkout). */
export const EGYPTIAN_GOVERNORATES = [
  "القاهرة",
  "الجيزة",
  "الإسكندرية",
  "البحيرة",
  "كفر الشيخ",
  "دمياط",
  "بور سعيد",
  "المنوفية",
  "القليوبية",
  "الغربية",
  "الشرقية",
  "السويس",
  "الدقهلية",
  "الإسماعيلية",
  "سوهاج",
  "بني سويف",
  "المنيا",
  "الفيوم",
  "أسيوط",
  "مرسى مطروح",
  "قنا",
  "البحر الأحمر",
  "الأقصر",
  "أسوان",
  "الساحل الشمالي",
  "الوادي الجديد",
  "جنوب سيناء",
];
